import Phaser from 'phaser';
import Background, {
  preload as preloadBackground,
} from '../../objects/test/Background';

export default class BackgroundObject extends Phaser.Scene {
  constructor() {
    super({ key: 'BackgroundObject', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadBackground.call(this, 'background_flat', '1.png');
    preloadBackground.call(this, 'background_trees', '3.png');
    preloadBackground.call(this, 'background_spiders', '4.png');
    preloadBackground.call(this, 'background_ground', '6.png');
  }

  create() {
    this.background_flat = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_flat',
    });
    this.background_trees = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_trees',
    });
    this.background_spiders = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_spiders',
    });
    this.background_ground = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_ground',
    });
  }
}
